import ProductList from './product'
export default ProductList
